(function () {

class DeliveryEstimate {
  constructor() {
    this.apiUrl = "https://loggi-estimate-lac.vercel.app/api/loggi-estimate";

    this.currentStorageKey = "canuts_saved_cep";
    this.legacyStorageKeys = [
      "canuts_saved_cep_v4",
      "canuts_saved_cep_v3",
      "canuts_saved_cep_v2",
      "canuts_saved_cep",
      "canuts_cep"
    ];

    this.specialCities = [
      "sao paulo",
      "santo andre",
      "sao bernardo do campo",
      "sao caetano do sul"
    ];

    this.fixedNationalHolidayMonthDays = [
      "01-01",
      "04-21",
      "05-01",
      "09-07",
      "10-12",
      "11-02",
      "11-15",
      "12-25"
    ];

    this.extraHolidayDates = Array.isArray(window.CANUTS_HOLIDAYS)
      ? window.CANUTS_HOLIDAYS
      : [];

    this.isCalculating = false;
    this.currentPayload = null;
    this.mutationDebounce = null;
    this.lastAutoCalculatedCep = "";

    this.init();
  }

  init() {
    this.bindEvents();
    this.primeAllWrappers();
    this.restoreAndRecalculate();
    this.observeDomChanges();
  }

  bindEvents() {

    document.addEventListener("click", async (event) => {
      const button = event.target.closest(".delivery-check-btn");
      if (!button) return;

      const wrapper = button.closest("[data-delivery-estimate]");
      if (!wrapper || !this.isWrapperActive(wrapper)) return;

      event.preventDefault();

      const input = wrapper.querySelector(".delivery-cep-input");
      const cep = this.cleanCep(input ? input.value : "");

      if (cep.length !== 8) {
        this.renderError("Digite um CEP válido");
        return;
      }

      wrapper.dataset.deliveryEditing = "false";
      this.saveCep(cep);
      this.lastAutoCalculatedCep = cep;
      await this.calculateAndRender(cep, { silent: false });
    });

    document.addEventListener("keydown", async (event) => {
      const input = event.target.closest(".delivery-cep-input");
      if (!input) return;
      if (event.key !== "Enter") return;

      const wrapper = input.closest("[data-delivery-estimate]");
      if (!wrapper || !this.isWrapperActive(wrapper)) return;

      event.preventDefault();

      const cep = this.cleanCep(input.value);

      if (cep.length !== 8) {
        this.renderError("Digite um CEP válido");
        return;
      }

      wrapper.dataset.deliveryEditing = "false";
      this.saveCep(cep);
      this.lastAutoCalculatedCep = cep;
      await this.calculateAndRender(cep, { silent: false });
    });

    document.addEventListener("input", async (event) => {
      const input = event.target.closest(".delivery-cep-input");
      if (!input) return;

      const wrapper = input.closest("[data-delivery-estimate]");
      if (!wrapper || !this.isWrapperActive(wrapper)) return;

      wrapper.dataset.deliveryEditing = "true";

      let value = this.cleanCep(input.value).slice(0, 8);

      if (value.length > 5) {
        value = value.replace(/^(\d{5})(\d+)/, "$1-$2");
      }

      input.value = value;

      const cep = this.cleanCep(value);

      if (cep.length < 8) {
        this.lastAutoCalculatedCep = "";
        return;
      }

      if (cep === this.lastAutoCalculatedCep || this.isCalculating) {
        return;
      }

      wrapper.dataset.deliveryEditing = "false";
      this.saveCep(cep);
      this.lastAutoCalculatedCep = cep;
      await this.calculateAndRender(cep, { silent: false });
    });

    document.addEventListener("focusin", (event) => {
      const input = event.target.closest(".delivery-cep-input");
      if (!input) return;

      const wrapper = input.closest("[data-delivery-estimate]");
      if (wrapper) {
        wrapper.dataset.deliveryEditing = "true";
      }
    });

    document.addEventListener("click", (event) => {
      const changeBtn = event.target.closest("[data-delivery-location]");
      if (!changeBtn) return;

      const wrapper = changeBtn.closest("[data-delivery-estimate]");
      if (!wrapper || !this.isWrapperActive(wrapper)) return;

      const form = wrapper.querySelector("[data-delivery-form]");
      const input = wrapper.querySelector(".delivery-cep-input");

      wrapper.dataset.deliveryEditing = "true";
      this.lastAutoCalculatedCep = "";

      if (form) form.classList.remove("delivery-hidden");
      if (input) input.focus();
    });

    const reapply = () => {
      this.primeAllWrappers();
    };

    document.addEventListener("change", (event) => {
      const el = event.target;
      if (!el || !(el instanceof Element)) return;

      const isVariantRelated =
        el.matches('select[name="id"]') ||
        el.matches('input[name="id"]') ||
        el.matches('[name="options[]"]') ||
        !!el.closest(".product-form") ||
        !!el.closest("variant-selects") ||
        !!el.closest("variant-radios");

      if (isVariantRelated) {
        reapply();
      }
    });

    document.addEventListener("shopify:section:load", reapply);
    document.addEventListener("shopify:section:reorder", reapply);
    document.addEventListener("cart:refresh", reapply);
    document.addEventListener("cart:updated", reapply);

    document.addEventListener("click", (event) => {
      const trigger = event.target.closest(
        '[href="/cart"], [data-cart-trigger], [data-drawer-trigger], .header__icon--cart, .cart-drawer-button, .js-drawer-open-cart'
      );
      if (!trigger) return;

      this.scheduleDrawerRefresh();
    });

    document.addEventListener("transitionend", (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const drawer = target.closest(
        ".drawer, .cart-drawer, .ajax-cart, cart-drawer, #CartDrawer, #cart-drawer"
      );
      if (!drawer) return;

      if (this.isDrawerOpen(drawer)) {
        this.scheduleDrawerRefresh();
      }
    });

    document.addEventListener("cart:open", () => {
      this.scheduleDrawerRefresh();
    });
  }

  observeDomChanges() {
    const observer = new MutationObserver(() => {
      clearTimeout(this.mutationDebounce);
      this.mutationDebounce = setTimeout(() => {
        this.primeAllWrappers();
      }, 80);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  scheduleDrawerRefresh() {
    const run = async () => {
      this.primeAllWrappers();

      const cep = this.getSavedCep();
      if (!cep) return;

      if (this.currentPayload && this.currentPayload.cep === cep) {
        this.applyPayloadToAll(this.currentPayload);
        return;
      }

      if (!this.isCalculating) {
        await this.calculateAndRender(cep, { silent: true });
      }
    };

    run();
    setTimeout(run, 120);
    setTimeout(run, 300);
    setTimeout(run, 600);
  }

  getAllWrappers() {
    return Array.from(document.querySelectorAll("[data-delivery-estimate]"));
  }

  getWrappers() {
    return this.getAllWrappers().filter((wrapper) => this.isWrapperActive(wrapper));
  }

  isWrapperActive(wrapper) {
    if (!wrapper || !document.body.contains(wrapper)) return false;

    const hiddenAncestor = wrapper.closest("[hidden], .hidden, .is-hidden");
    if (hiddenAncestor) return false;

    const drawer = wrapper.closest(
      ".drawer, .cart-drawer, .ajax-cart, cart-drawer, #CartDrawer, #cart-drawer"
    );

    if (!drawer) return true;

    return this.isDrawerOpen(drawer);
  }

  isDrawerOpen(drawer) {
    if (!drawer) return true;

    if (drawer.matches("[open], .is-open, .active, .drawer--active, .js-open")) {
      return true;
    }

    const ariaHidden = drawer.getAttribute("aria-hidden");
    if (ariaHidden === "false") return true;

    const hidden = drawer.getAttribute("hidden");
    if (hidden !== null) return false;

    const style = window.getComputedStyle(drawer);

    if (style.display === "none" || style.visibility === "hidden") return false;

    const rect = drawer.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return false;

    return true;
  }

  primeAllWrappers() {
    const cep = this.getSavedCep();

    this.getAllWrappers().forEach((wrapper) => {
      if (!this.isWrapperActive(wrapper)) {
        return;
      }

      this.primeWrapper(wrapper, cep);
    });
  }

  primeWrapper(wrapper, cep) {
    const input = wrapper.querySelector(".delivery-cep-input");
    const form = wrapper.querySelector("[data-delivery-form]");
    const result = wrapper.querySelector(".delivery-result");
    const locationBtn = wrapper.querySelector("[data-delivery-location]");
    const locationText = wrapper.querySelector(".delivery-location-text");
    const isEditing = wrapper.dataset.deliveryEditing === "true";

    if (input && cep && document.activeElement !== input) {
      input.value = this.maskCep(cep);
    }

    if (isEditing) {
      if (form) form.classList.remove("delivery-hidden");
      if (locationBtn) locationBtn.classList.remove("delivery-hidden");
      wrapper.setAttribute("data-delivery-ready", "true");
      return;
    }

    if (this.currentPayload && cep && this.currentPayload.cep === cep) {
      if (result) result.innerHTML = this.currentPayload.message;
      if (locationText) locationText.textContent = this.currentPayload.location;
      if (locationBtn) locationBtn.classList.remove("delivery-hidden");
      if (form) form.classList.add("delivery-hidden");
      wrapper.setAttribute("data-delivery-ready", "true");
      return;
    }

    if (cep) {
      if (form) form.classList.add("delivery-hidden");
      if (locationBtn) locationBtn.classList.remove("delivery-hidden");
      if (locationText) locationText.textContent = `Enviar para ${this.maskCep(cep)}`;
      wrapper.setAttribute("data-delivery-ready", "true");
      return;
    }

    if (form) form.classList.remove("delivery-hidden");
    if (locationBtn) locationBtn.classList.add("delivery-hidden");
    wrapper.setAttribute("data-delivery-ready", "true");
  }

  async restoreAndRecalculate() {
    const cep = this.getSavedCep();
    if (!cep) {
      this.primeAllWrappers();
      return;
    }

    this.fillInputsWithCep(cep);
    this.primeAllWrappers();
    this.lastAutoCalculatedCep = cep;

    await this.calculateAndRender(cep, { silent: true });
  }

  async calculateAndRender(cep, options = {}) {
    const { silent = false } = options;

    if (this.isCalculating) return;

    this.isCalculating = true;

    if (!silent) {
      this.setButtonsLoading(true);
    }

    try {
      const address = await this.fetchCepData(cep);
      const payload = await this.buildEstimatePayload(cep, address);

      this.currentPayload = payload;
      this.applyPayloadToAll(payload);
      await this.saveCepToCartAttributes(cep);
    } catch (error) {
      console.error("Erro ao calcular prazo:", error);

      if (!silent) {
        this.renderError("Não foi possível calcular o prazo no momento");
      }
    } finally {
      if (!silent) {
        this.setButtonsLoading(false);
      }

      this.isCalculating = false;
    }
  }

  async buildEstimatePayload(cep, address) {
    const now = this.getBrazilNow();

    let location = `Enviar para ${this.maskCep(cep)}`;
    if (address && address.localidade && address.uf) {
      location = `Enviar para ${address.localidade} - ${address.uf} ${this.maskCep(cep)}`;
    }

    let message = "";

    if (this.isSpecialCity(address)) {
      message = this.buildSpecialCityMessage(now);
    } else {
      const shippingData = await this.fetchDeliveryEstimate(cep);

      if (!shippingData || typeof shippingData.days !== "number" || shippingData.days < 1) {
        throw new Error("Resposta inválida da API");
      }

      message = this.buildLoggiMessage(now, shippingData.days);
    }

    return {
      cep,
      location,
      message
    };
  }

  buildSpecialCityMessage(now) {
    const hour = now.getHours();
    const day = now.getDay();

    if (day === 5 && hour < 10) {
      return `<span class="delivery-date-highlight">Chegará amanhã</span>`;
    }

    if (day !== 5 && this.isTomorrowBusinessDay(now)) {
      return `<span class="delivery-date-highlight">Chegará amanhã</span>`;
    }

    const startOffset = 1;
    const endOffset = 2;

    const startDate = this.addBusinessDays(now, startOffset);
    const endDate = this.addBusinessDays(now, endOffset);

    const start = this.formatDate(startDate);
    const end = this.formatDate(endDate);

    return `Chegará entre <span class="delivery-date-highlight">${start}</span> e <span class="delivery-date-highlight">${end}</span>`;
  }

  buildLoggiMessage(now, prazoLoggi) {
    const startOffset = Math.ceil(prazoLoggi);
    const endOffset = startOffset + 1;

    const startDate = this.addBusinessDays(now, startOffset);
    const endDate = this.addBusinessDays(now, endOffset);

    const start = this.formatDate(startDate);
    const end = this.formatDate(endDate);

    return `Chegará entre <span class="delivery-date-highlight">${start}</span> e <span class="delivery-date-highlight">${end}</span>`;
  }

  applyPayloadToAll(payload) {
    this.getWrappers().forEach((wrapper) => {
      const result = wrapper.querySelector(".delivery-result");
      const locationText = wrapper.querySelector(".delivery-location-text");
      const locationBtn = wrapper.querySelector("[data-delivery-location]");
      const form = wrapper.querySelector("[data-delivery-form]");
      const input = wrapper.querySelector(".delivery-cep-input");

      wrapper.dataset.deliveryEditing = "false";

      if (input) {
        input.value = this.maskCep(payload.cep);
      }

      if (result) {
        result.innerHTML = payload.message;
      }

      if (locationText) {
        locationText.textContent = payload.location;
      }

      if (locationBtn) {
        locationBtn.classList.remove("delivery-hidden");
      }

      if (form) {
        form.classList.add("delivery-hidden");
      }

      wrapper.setAttribute("data-delivery-ready", "true");
    });
  }

  renderError(message) {
    this.getWrappers().forEach((wrapper) => {
      const result = wrapper.querySelector(".delivery-result");
      const form = wrapper.querySelector("[data-delivery-form]");

      wrapper.dataset.deliveryEditing = "true";

      if (result) {
        result.textContent = message;
      }

      if (form) {
        form.classList.remove("delivery-hidden");
      }

      wrapper.setAttribute("data-delivery-ready", "true");
    });
  }

  setButtonsLoading(isLoading) {
    this.getWrappers().forEach((wrapper) => {
      const button = wrapper.querySelector(".delivery-check-btn");
      if (!button) return;

      if (isLoading) {
        button.disabled = true;
        button.textContent = "Consultando";
        button.classList.add("is-loading");
      } else {
        button.disabled = false;
        button.textContent = "OK";
        button.classList.remove("is-loading");
      }
    });
  }

  fillInputsWithCep(cep) {
    this.getWrappers().forEach((wrapper) => {
      const input = wrapper.querySelector(".delivery-cep-input");
      if (input) {
        input.value = this.maskCep(cep);
      }
    });
  }

  saveCep(cep) {
    localStorage.setItem(this.currentStorageKey, cep);
  }

  getSavedCep() {
    for (const key of this.legacyStorageKeys) {
      const value = localStorage.getItem(key);
      const cep = this.cleanCep(value || "");

      if (cep.length === 8) {
        localStorage.setItem(this.currentStorageKey, cep);
        return cep;
      }
    }

    return "";
  }

  cleanCep(value) {
    return String(value || "").replace(/\D/g, "");
  }

  maskCep(cep) {
    return cep.replace(/^(\d{5})(\d{3})$/, "$1-$2");
  }

  async fetchDeliveryEstimate(cep) {
    let response;

    try {
      response = await fetch(this.apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({ cep })
      });
    } catch (error) {
      console.error("Falha de rede ao chamar API de prazo:", error);
      throw new Error("Falha de rede ao chamar API");
    }

    const rawText = await response.text();

    if (!response.ok) {
      throw new Error(`Erro na API: ${response.status} - ${rawText}`);
    }

    let data;
    try {
      data = JSON.parse(rawText);
    } catch (error) {
      throw new Error("JSON inválido retornado pela API");
    }

    if (typeof data.days !== "number") {
      throw new Error("Formato inválido da resposta da API");
    }

    return data;
  }

  async fetchCepData(cep) {
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const data = await response.json();

      if (data.erro) return null;
      return data;
    } catch (error) {
      return null;
    }
  }

  async saveCepToCartAttributes(cep) {
    try {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          attributes: {
            cep_entrega: this.maskCep(cep)
          }
        })
      });
    } catch (error) {
      console.error("Erro ao salvar CEP no carrinho:", error);
    }
  }

  isSpecialCity(address) {
    if (!address || !address.localidade || !address.uf) return false;
    if (this.normalizeText(address.uf) !== "sp") return false;

    const city = this.normalizeText(address.localidade);
    return this.specialCities.includes(city);
  }

  isTomorrowBusinessDay(date) {
    const tomorrow = this.addCalendarDays(date, 1);
    return this.isBusinessDay(tomorrow);
  }

  isBusinessDay(date) {
    const day = date.getDay();
    const isWeekend = day === 0 || day === 6;

    if (isWeekend) return false;
    if (this.isHoliday(date)) return false;

    return true;
  }

  isHoliday(date) {
    const iso = this.formatIsoDate(date);
    const monthDay = iso.slice(5);

    if (this.extraHolidayDates.includes(iso)) {
      return true;
    }

    if (this.fixedNationalHolidayMonthDays.includes(monthDay)) {
      return true;
    }

    return false;
  }

  addBusinessDays(date, days) {
    const result = new Date(date);
    let added = 0;

    while (added < days) {
      result.setDate(result.getDate() + 1);

      if (this.isBusinessDay(result)) {
        added++;
      }
    }

    return result;
  }

  addCalendarDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  getBrazilNow() {
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: "America/Sao_Paulo",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false
    });

    const parts = formatter.formatToParts(new Date());
    const map = {};

    parts.forEach((part) => {
      if (part.type !== "literal") {
        map[part.type] = part.value;
      }
    });

    return new Date(
      Number(map.year),
      Number(map.month) - 1,
      Number(map.day),
      Number(map.hour),
      Number(map.minute),
      Number(map.second)
    );
  }

  formatDate(date) {
    return date.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit"
    });
  }

  formatIsoDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  normalizeText(text) {
    return String(text || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new DeliveryEstimate();
});

})();